<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <b-card>
                    <div slot="header">
                        <i :class="[isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']"></i><strong> Klassiek belichtingsschema</strong>
                        <small>
                            <span v-show="schemabestaat">wijzigen</span>
                            <span v-show="!schemabestaat">creëren</span>
                        </small>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-striped table-sm">
                                <tbody>
                                <tr>
                                    <th>Afdeling: </th><td>{{model.afdeling.naam}}</td>

                                </tr>
                                <tr>
                                    <th>Gewas: </th><td>{{model.teelt.naam}} - {{model.ras}}</td>
                                    <th>Aanplantdatum - einddatum: </th>
                                    <td>{{datumDDMMYYYY(model.aanplantdatum)}} - {{datumDDMMYYYY(model.einddatum)}}</td>
                                </tr>
                                <tr>
                                    <th>Gewenste DLI: </th><td>{{model.ingesteldeDli}}</td>
                                    <th>Belichtingsseizoen start - einde: </th>
                                    <td>{{datumDDMMYYYY(model.startdatumBelichting)}} - {{datumDDMMYYYY(model.einddatumBelichting)}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            &nbsp;<br />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-striped table-sm">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th>Installatie (&#181;mol/m<sup>2</sup>s)</th>
                                    <th>Efficiëntie (&#181;mol/J)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(belichting, indexi, i) in model.afdeling.belichting_n">
                                    <template v-for="(schakelniveau, indexj, i) in belichting.schakelniveau_n">
                                        <tr>
                                            <td>Systeem {{schakelniveau.nummer + 1}}</td>
                                            <td>{{belichting.soortbelichting.naam}} {{indexj + 1}}</td>
                                            <td>{{komma4(installatie[schakelniveau.nummer])}}</td>
                                            <td>{{belichting.efficientie}}</td>
                                        </tr>
                                    </template>
                                </template>

                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            &nbsp;<br />
                        </div>
                    </div>

                    <div v-show="!schemabestaat" class="row">
                        <div class="col-12">
                            <p class="red">Er bestaat nog geen klassiek belichtingsschema voor deze teelt.</p>
                        </div>
                        <div class="col-12">
                            &nbsp;<br />
                        </div>
                    </div>

                    <div v-show="schemabestaat" class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <b-button-group id="periode" name="periode">
                                    <b-button @click="changeView('data')" variant="outline-secondary" :pressed="currentview == 'data'">Data</b-button>
                                    <b-button @click="changeView('grafiek')" variant="outline-secondary" :pressed="currentview == 'grafiek'">Grafiek</b-button>
                                </b-button-group>
                            </div>
                            &nbsp<br />
                        </div><!--/.col-->

                        <div v-show="currentview == 'data'" class="col-sm-6" align="right">
                            <b-button type="button" @click="openFormImport()" variant="secondary" style="background-color : #ffffff;">Belichtingsschema importeren</b-button>
                        </div><!--/.col-->

                        <div v-show="currentview == 'grafiek'" class="col-sm-6">
                            <b-input-group>
                                <b-input-group left="Van">
                                    <datepicker @input="fillGraphData()" :language="nl" :required="true" v-model="begindatum" :bootstrapStyling="true" style="background-color : #ffffff;" :disabled-dates="disabled" :full-month-name="true" :monday-first="true" name="begindatum" id="begindatum" ref="begindatum" format="d MMMM yyyy" minimumView="day" maximumView="year" initialView="day"></datepicker>
                                </b-input-group>
                                &nbsp;&nbsp;
                                <b-input-group left="Tot">
                                    <datepicker @input="fillGraphData()" :language="nl" :required="true" v-model="einddatum" :bootstrapStyling="true" style="background-color : #ffffff;" :disabled-dates="disabled" :full-month-name="true" :monday-first="true" name="einddatum" id="einddatum" ref="einddatum" format="d MMMM yyyy" minimumView="day" maximumView="year" initialView="day"></datepicker>
                                </b-input-group>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </b-input-group>
                        </div><!--/.col-->
                    </div>

                    <div v-if="schemabestaat && currentview == 'data'" class="row animated fadeIn">
                        <div class="col-12">
                            <table class="table table-striped table-sm text-center table-fixed">
                                <thead>
                                <tr>
                                    <th>Datum</th>
                                    <th>DLI gewenst (mol/m<sup>2</sup>)</th>
                                    <th>DLI zon (mol/m<sup>2</sup>)</th>
                                    <th></th>
                                    <th style="text-align: center;" :colspan="aantalsystemen">Belichtingsuren</th>
                                    <th style="text-align: center;" :colspan="aantalsystemen">DLI belichting (mol/m<sup>2</sup>)</th>
                                    <th>DLI werkelijk<br />ontvangen (mol/m<sup>2</sup>)</th>
                                    <th>DLI cumulatief (mol/m<sup>2</sup>)</th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <template v-for="i in aantalsystemen">
                                        <th style="text-align: center;">{{i}}</th>
                                    </template>
                                    <template v-for="i in aantalsystemen">
                                        <th style="text-align: center;">{{i}}</th>
                                    </template>
                                    <th></th>
                                    <th>{{komma1(model.cumulatief)}}</th>
                                </tr>

                                <!-- truukje om kolommen overeen te laten komen -->
                                <tr style="visibility: collapse">
                                    <td>29/02/2020</td>
                                    <td>22.0</td>
                                    <td>22.0</td>
                                    <td>
                                        <a href="javascript:void(0)">
                                            <i class="fa fa-navicon"></i>
                                        </a>
                                    </td>
                                    <template v-for="perdag in model.klassiekebelichting_n[0].klassiekperdag_n">
                                        <td style="text-align: center;">
                                            <div class="centered">
                                                <input type="text" v-mask="'##:##'" class="form-control unstyleduur" />
                                            </div>
                                        </td>
                                    </template>
                                    <template v-for="perdag in model.klassiekebelichting_n[0].klassiekperdag_n">
                                        <td style="text-align: center;">
                                            0.22
                                        </td>
                                    </template>
                                    <td>22.0</td>
                                    <td>{{komma1(dlicumulatief[model.klassiekebelichting_n.length - 1])}}</td>
                                </tr>
                                <!-- tot hier -->

                                </thead>

                                <tbody>

                                <!-- truukje om kolommen overeen te laten komen -->
                                <tr style="visibility: collapse">
                                    <th>Datum</th>
                                    <th>DLI gewenst (mol/m<sup>2</sup>)</th>
                                    <th>DLI zon (mol/m<sup>2</sup>)</th>
                                    <th></th>
                                    <th style="text-align: center;" :colspan="aantalsystemen">Belichtingsuren</th>
                                    <th style="text-align: center;" :colspan="aantalsystemen">DLI belichting (mol/m<sup>2</sup>)</th>
                                    <th>DLI werkelijk<br />ontvangen (mol/m<sup>2</sup>)</th>
                                    <th>DLI cumulatief (mol/m<sup>2</sup>)</th>
                                </tr>
                                <tr style="visibility: collapse">
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <template v-for="i in aantalsystemen">
                                        <th style="text-align: center;">{{i}}</th>
                                    </template>
                                    <template v-for="i in aantalsystemen">
                                        <th style="text-align: center;">{{i}}</th>
                                    </template>
                                    <th></th>
                                    <th>{{komma1(model.cumulatief)}}</th>
                                </tr>
                                <!-- tot hier -->

                                <tr v-for="(klassiek, indexi) in model.klassiekebelichting_n">
                                    <td>{{datumDDMMYYYY(klassiek.datum)}}</td>
                                    <td>{{klassiek.gewensteDli}}</td>
                                    <td>{{klassiek.dliZon}}</td>
                                    <td>
                                        <a href="javascript:void(0)" @click="klikt(indexi)">
                                            <i v-bind:class="selectValue(klassiek)"></i>
                                        </a>
                                    </td>
                                    <template v-for="(perdag, indexj) in klassiek.klassiekperdag_n">
                                        <td style="text-align: center;"><!-- {{perdag.tijd}} -->
                                            <!-- zeker niet meer dan 50 schakelniveaus per afdeling -->
                                            <div class="centered">
                                                <input type="text" v-mask="'##:##'" required @keyup.delete="wis(perdag)" class="form-control unstyleduur" v-model="perdag.tijd" :id="'tijd' + ((indexi * 50) + indexj)" :name="'tijd' + ((indexi * 50) + indexj)" />
                                                <!-- <input required @keyup.delete="wis(perdag)" type="time" class="form-control unstyleduur" v-model="perdag.tijd" id="tijd" name="'tijd' + ((indexi * 50) + indexj)" /> -->
                                            </div>
                                        </td>
                                    </template>
                                    <template v-for="(perdag, indexj) in klassiek.klassiekperdag_n">
                                        <td style="text-align: center;">{{komma2(dlibelichting[indexi].perdag[indexj].mol)}}</td>
                                    </template>
                                    <td v-bind:class="genoegLicht(klassiek.gewensteDli, parseFloat(dlitotaal[indexi]))">{{komma1(dlitotaal[indexi])}}</td>
                                    <td>{{komma1(dlicumulatief[indexi])}}</td>
                                </tr>

                                </tbody>
                            </table>
                        </div><!--/.col-->
                    </div><!--/.row-->

                    <div v-show="schemabestaat && currentview == 'grafiek'" class="row animated fadeIn">
                        <div class="col-12">
                            <h5 class="card-title mb-0">Klassiek belichtingsschema</h5>
                            <br />
                            <div class="small text-muted">mol/m<sup>2</sup></div>
                            <chart :chart-data="datacollection" class="chart-wrapper" style="height:400px;margin-top:10px;margin-bottom:40px;" height="400" :miny="miny" :maxy="maxy" :changeyaxis="changeyaxis"></chart>
                        </div>
                    </div>

                    <form @submit.prevent="saveItem">

                    <div slot="footer">
                        <b-button v-show="schemabestaat" type="submit" variant="primary">
                            <span>Opslaan</span>
                        </b-button>
                        <b-button v-show="!schemabestaat" type="button" @click="createschema" variant="primary">Belichtingsschema creëren</b-button>
                        <b-button type="button" @click="back" variant="secondary">Annuleren</b-button>
                    </div>

                    </form>

                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import { nl } from 'vuejs-datepicker/dist/locale';

    import datefunctions from '../../helpers/datefunctions';
    import Chart from './ChartMixed';

    export default {
        name: 'Form',
        props: ['model', 'isEditing'],
        data () {
            return {
                nl,
                firstrow: -1,
                currentview: 'data',
                datacollection: null,
                miny: 0,
                maxy: 25,
                changeyaxis: false, // telkens deze wijzigt, hertekent de grafiek zich
                begindatum: '',
                einddatum: '',
                disabled: {
                    to: new Date(),
                    from: new Date(),
                },
                bordercolors: ['rgba(255, 128, 0, 1)', 'rgba(0, 204, 204, 1)', 'rgba(255,20,147, 1)', 'rgba(255,221,50,1)', 'rgba(0, 0, 102,1)', 'rgba(193,46,12,1)', 'rgba(0,0,0,1)', 'rgba(50,205,50,1)', 'rgba(72,209,204,1)', 'rgba(139,0,139,1)'],
                fillcolors: ['rgba(255, 128, 0, 0.2)', 'rgba(0, 204, 204, 0.2)', 'rgba(255,20,147, 0.2)', 'rgba(255,221,50,0.2)', 'rgba(0, 0, 102,0.2)', 'rgba(193,46,12,0.2)', 'rgba(0,0,0,0.2)', 'rgba(50,205,50,0.2)', 'rgba(72,209,204,0.2)', 'rgba(139,0,139,0.2)'],
            };
        },
        methods: {
            changeView (view) {
                this.currentview = view;
                if (view === 'grafiek') {
                    if (this.begindatum === '') {
                        this.begindatum = new Date(this.model.klassiekebelichting_n[0].datum);
                        this.einddatum = new Date(this.model.klassiekebelichting_n[this.model.klassiekebelichting_n.length - 1].datum);
                        this.disabled.to = this.begindatum;
                        this.disabled.from = this.einddatum;
                    }
                    this.fillGraphData();
                }
            },
            getMaxValueDatasets (datasets) {
                let maxwaarde = 0;
                datasets.forEach((dataset) => {
                    maxwaarde = Math.max(maxwaarde, Math.max(...dataset.data));
                });
                return (Math.floor((maxwaarde - 0.00000001) / 5) + 1) * 5;
            },
            fillGraphData () {
                this.datacollection = {
                    type: 'bar',
                    labels: this.getGraphLabels(),
                    datasets: this.getGraphBarsAndLines(),
                };
                this.miny = 0;
                this.maxy = this.getMaxValueDatasets(this.datacollection.datasets);
                this.changeyaxis = !this.changeyaxis;
            },
            getGraphLabels () {
                const labels = [];
                this.model.klassiekebelichting_n.forEach((klassiek) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        labels.push(this.datumDDMMYYYY(klassiek.datum));
                    }
                });
                return labels;
            },
            getGraphBarsAndLines () {
                const datasets = [];
                this.getGraphSystemen(datasets);
                this.getGraphDliZon(datasets);
                this.getGraphDliGewenst(datasets);
                this.getGraphDliTotaal(datasets);
                return datasets;
            },
            getGraphSystemen (datasets) {
                for (let i = 0; i < this.aantalsystemen; i += 1) {
                    const dataset = {
                        backgroundColor: this.fillcolors[(i % 10)],
                        borderColor: this.bordercolors[(i % 10)],
                        pointHoverBackgroundColor: '#fff',
                        borderWidth: 1,
                        label: this.getSysteemNaam(i),
                        data: this.getGraphData(i),
                        yAxisID: 'bar',
                    };
                    datasets.push(dataset);
                }
            },
            getSysteemNaam (gezocht) {
                let naam = '';
                let index = 0;
                for (let i = 0; i < this.model.afdeling.belichting_n.length; i += 1) {
                    let nr = 1;
                    for (let j = 0; j < this.model.afdeling.belichting_n[i].schakelniveau_n.length; j += 1) {
                        if (index === gezocht) {
                            naam = `${this.model.afdeling.belichting_n[i].soortbelichting.naam} ${nr}`;
                        }
                        index += 1;
                        nr += 1;
                    }
                }
                return naam;
            },
            getGraphData (i) {
                const data = [];
                for (let j = 0; j < this.model.klassiekebelichting_n.length; j += 1) {
                    if ((this.model.klassiekebelichting_n[j].datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (this.model.klassiekebelichting_n[j].datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(this.dlibelichting[j].perdag[i].mol));
                    }
                }
                return data;
            },
            getGraphDliZon (datasets) {
                const data = [];
                this.model.klassiekebelichting_n.forEach((klassiek) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(klassiek.dliZon);
                    }
                });
                const dataset = {
                    backgroundColor: 'rgba(25,25,112, 0)',
                    borderColor: 'rgba(25,25,112, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: ' DLI zon',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            getGraphDliGewenst (datasets) {
                const data = [];
                this.model.klassiekebelichting_n.forEach((klassiek) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(klassiek.gewensteDli);
                    }
                });
                const dataset = {
                    backgroundColor: 'rgba(23,23,23, 0)',
                    borderColor: 'rgba(23,23,23, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: ' DLI gewenst',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            getGraphDliTotaal (datasets) {
                const data = [];
                for (let j = 0; j < this.model.klassiekebelichting_n.length; j += 1) {
                    if ((this.model.klassiekebelichting_n[j].datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (this.model.klassiekebelichting_n[j].datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma1(this.dlitotaal[j]));
                    }
                }
                const dataset = {
                    backgroundColor: 'rgba(178,34,34, 0)',
                    borderColor: 'rgba(178,34,34, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: ' DLI werkelijk ontvangen',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            wis (perdag) {
                perdag.tijd = '00:00';
                /*
                @keyup.delete="wis(perdag, $event)"
                wis (perdag, event) {
                console.log(event.target);
                event.preventDefault();
                event.target.focus();
                event.target.select(); */
            },
            klikt (index) {
                if (this.model.klassiekebelichting_n[index].selected === 0) {
                    if (this.firstrow === -1) {
                        this.model.klassiekebelichting_n[index].selected = 1;
                        this.firstrow = index;
                    } else if (this.firstrow < index) {
                        for (let i = this.firstrow + 1; i <= index; i += 1) {
                            for (let j = 0; j < this.model.klassiekebelichting_n[this.firstrow].klassiekperdag_n.length; j += 1) {
                                this.model.klassiekebelichting_n[i].klassiekperdag_n[j].tijd =
                                    this.model.klassiekebelichting_n[this.firstrow].klassiekperdag_n[j].tijd;
                            }
                        }
                        this.model.klassiekebelichting_n[this.firstrow].selected = 0;
                        this.firstrow = -1;
                    }
                } else {
                    this.model.klassiekebelichting_n[index].selected = 0;
                    this.firstrow = -1;
                }
            },
            selectValue (klassiek) {
                if (klassiek.selected === 0) {
                    return 'fa fa-navicon';
                }
                if (klassiek.selected === 1) {
                    return 'fa fa-sort-amount-asc';
                }
                return '';
            },
            genoegLicht (nodig, hebje) {
                if (hebje >= nodig) {
                    return 'green';
                }
                if (hebje >= (nodig * 0.75)) {
                    return 'orange';
                }
                return 'red';
            },
            createschema () {
                this.$emit('create-schema', this.model);
            },
            openFormImport () {
                this.$emit('open-form-import', this.model);
            },
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (!this.isError) {
                            this.$emit('save-item', this.model);
                        }
                    }
                });
            },
            back () {
                this.$router.go(-1);
            },
            datumDDMMYYYY (datum) {
                return datefunctions.datetoDDMMYYYY(datum);
            },
            timeHHMM (time) {
                return datefunctions.timetoHHMM(time);
            },
            berekenVermogen (schakelniveau, belichting) {
                /* eslint max-len: ["error", { "code": 300 }] */
                return (belichting.fotonflux * schakelniveau.percentage) / 100;
            },
            komma4 (waarde) {
                if (isNaN(waarde)) {
                    return '#.####';
                }
                return waarde.toFixed(4);
            },
            komma2 (waarde) {
                if (isNaN(waarde)) {
                    return '#.##';
                }
                return waarde.toFixed(2);
            },
            komma1 (waarde) {
                if (isNaN(waarde)) {
                    return '#.#';
                }
                return waarde.toFixed(1);
            },
            komma0 (waarde) {
                if (isNaN(waarde)) {
                    return '#';
                }
                return waarde.toFixed(0);
            },
        },
        computed: {
            schemabestaat () {
                return (this.model.klassiekebelichting_n.length !== 0);
            },
            aantalsystemen () {
                let aantal = 0;
                this.model.afdeling.belichting_n.forEach((belichting) => {
                    aantal += belichting.schakelniveau_n.length;
                });
                return aantal;
            },
            dlibelichting () {
                const resultaat = [];
                this.model.klassiekebelichting_n.forEach((klassiek) => {
                    const perdagarray = [];
                    klassiek.klassiekperdag_n.forEach((perdag, i) => {
                        perdagarray.push({ mol: ((datefunctions.getSeconden(perdag.tijd)
                            * this.installatie[i]) / 1000000) });
                    });
                    resultaat.push({ datum: klassiek.datum, perdag: perdagarray });
                });
                return resultaat;
            },
            dlitotaal () {
                const resultaat = [];
                let i = 0;
                this.dlibelichting.forEach((dlibelichting) => {
                    let totaal = 0;
                    dlibelichting.perdag.forEach((perdag) => {
                        totaal += perdag.mol;
                    });
                    totaal += parseFloat(this.model.klassiekebelichting_n[i].dliZon);
                    resultaat.push(totaal);
                    i += 1;
                });
                return resultaat;
            },
            dlicumulatief () {
                const resultaat = [];
                let vorigtotaal = this.model.cumulatief;
                this.dlitotaal.forEach((dlitotaal) => {
                    resultaat.push(vorigtotaal + dlitotaal);
                    vorigtotaal += dlitotaal;
                });
                return resultaat;
            },
            installatie () {
                const resultaat = [];
                this.model.afdeling.belichting_n.forEach((belichting) => {
                    belichting.schakelniveau_n.forEach((schakelniveau) => {
                        resultaat.push(this.berekenVermogen(schakelniveau, belichting));
                    });
                });
                return resultaat;
            },
        },
        components: {
            datepicker: Datepicker,
            chart: Chart,
        },
    };
</script>

<style>

    .red {
        color: red;
    }
    .green {
        color: lawngreen;
    }
    .orange {
        color: orange;
    }

    input, select {
        padding: .55em .5em;
        font-size: 100%;
        border: 1px solid #ccc;
        width: 100%
    }

    .unstyleduur {
        padding: 0.1em;
        width: 3em;
        text-align: center;
    }

    .centered {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .unstyleduur::-webkit-outer-spin-button, /* Removes arrows */
    .unstyleduur::-webkit-inner-spin-button, /* Removes arrows */
    .unstyleduur::-webkit-clear-button { /* Removes blue cross */
        -webkit-appearance: none;
        margin: 0;
    }
    /*.unstyleduur::-webkit-calendar-picker-indicator {
      display: none;
      -webkit-appearance: none;
    }*/

    .table-nonfluid {
        width: auto !important;
    }

    .table-fixed tbody {
        height: calc( 100vh - 250px );
        overflow-y: auto;
    }

    .table-fixed thead, .table-fixed tbody {
        display: block;
    }

</style>



// WEBPACK FOOTER //
// src/pages/licht/FormKlassiek.vue